import JSZip from 'jszip';
import { addExtensionToBase64File } from '@/ui/helpers/fileHelper';
import { dataURLtoBlob } from '@/_legacy/util/blob';

export const compactImagesFromDataUrl = async (
  dataUrls: string[],
  imagePrefix = 'image_',
  base64 = true,
): Promise<Blob> => {
  const zip = new JSZip();
  const blobs = dataUrls.map(dataURLtoBlob);

  blobs.forEach((blob, index) => {
    zip.file(addExtensionToBase64File(dataUrls[index], `${imagePrefix}${index}`), blob, { base64 });
  });

  return zip.generateAsync({ type: 'blob' });
};
